import React from "react";
import { Rocket } from "lucide-react";

const themes = {
  student: {
    cardGradient: "from-white to-[#FFF7F4]",
    primaryGlow: "bg-[#FF6636]/10",
    secondaryGlow: "bg-[#089BC4]/10",
    iconGradient: "from-[#FF6636] to-[#FF8A63]",
    buttonClass: "bg-[#FF6636]",
    dotPrimary: "bg-[#FF6636]",
    dotSecondary: "bg-[#089BC4]",
    dotTertiary: "bg-[#16A34A]",
  },
  instructor: {
    cardGradient: "from-white to-[#EEF9FC]",
    primaryGlow: "bg-[#089BC4]/15",
    secondaryGlow: "bg-[#0CB4E0]/10",
    iconGradient: "from-[#089BC4] to-[#0CB4E0]",
    buttonClass: "bg-[#089BC4]",
    dotPrimary: "bg-[#089BC4]",
    dotSecondary: "bg-[#0CB4E0]",
    dotTertiary: "bg-[#16A34A]",
  },
};

const ComingSoonOverlay = ({
  title = "Coming Soon",
  description = "We're working hard to bring this feature to you. Stay tuned for exciting updates!",
  buttonText = "Stay Tuned",
  variant = "student",
}) => {
  const theme = themes[variant] || themes.student;

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-white/70 backdrop-blur-md px-4">
      <div
        className={`relative w-full max-w-2xl overflow-hidden rounded-3xl border border-white/40 bg-gradient-to-br ${theme.cardGradient} p-8 sm:p-10 shadow-[0_20px_60px_rgba(0,0,0,0.15)]`}
      >
        <div
          className={`absolute -left-16 -top-16 h-40 w-40 rounded-full ${theme.primaryGlow} blur-3xl`}
        />
        <div
          className={`absolute -bottom-20 -right-20 h-52 w-52 rounded-full ${theme.secondaryGlow} blur-3xl`}
        />

        <div className="relative z-10 text-center">
          <div
            className={`mx-auto mb-8 flex h-24 w-24 animate-bounce items-center justify-center rounded-full bg-gradient-to-br ${theme.iconGradient} shadow-xl`}
          >
            <Rocket className="h-12 w-12 text-white" strokeWidth={2.5} />
          </div>

          <h2 className="text-3xl font-bold text-[#1F2937] sm:text-4xl">
            {title}
          </h2>

          <p className="mx-auto mt-5 max-w-lg text-sm leading-7 text-[#6B7280] sm:text-lg">
            {description}
          </p>

          <div
            className={`mt-8 inline-flex rounded-full ${theme.buttonClass} px-8 py-3 text-base font-semibold text-white shadow-lg`}
          >
            🚧 {buttonText}
          </div>

          <div className="mt-8 flex justify-center gap-2">
            <span
              className={`h-3 w-3 animate-bounce rounded-full ${theme.dotPrimary}`}
            />
            <span
              className={`h-3 w-3 animate-bounce rounded-full ${theme.dotSecondary}`}
              style={{ animationDelay: "150ms" }}
            />
            <span
              className={`h-3 w-3 animate-bounce rounded-full ${theme.dotTertiary}`}
              style={{ animationDelay: "300ms" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonOverlay;
